import React from 'react';
import { Badge } from '../../Global/Icons';

function NewBadge({ shouldShow }) {
	if (!shouldShow) {
		return null;
	}

	return (
		<div className="pet-picker__list__item__new-badge">
			<Badge />
			<div className="new-badge__new">New</div>
		</div>
	);
}

export default NewBadge;



// WEBPACK FOOTER //
// ./src/components/Extension/PetPicker/NewBadge.js